import { motion } from "framer-motion";

function PricingHero() {
  return (
    <section className="py-20 px-4 text-center relative">
      <div className="container mx-auto max-w-4xl">
        <motion.div
          className="mb-6 inline-block"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="bg-[#fff5eb] px-4 py-2 rounded-full border border-[#ff8c42]/20">
            <span className="text-[#ff8c42] font-medium">Simple, Transparent Pricing</span>
          </div>
        </motion.div>
        
        <motion.h1 
          className="text-4xl md:text-6xl font-bold mb-6 text-[#694e42]"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          Choose the Plan That <br />
          <span className="bg-gradient-to-r from-[#946e5d] to-[#ff8c42] bg-clip-text text-transparent">
            Fits Your Needs
          </span>
        </motion.h1>
        
        <motion.p 
          className="text-xl text-[#8a7266] mb-8 max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          Start with our free plan and scale as you grow. No hidden fees, no commitments, upgrade or downgrade anytime.
        </motion.p>
        
        {/* Billing toggle */}
        <motion.div
          className="flex items-center justify-center space-x-4 mb-12"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <span className="text-[#694e42] font-medium">Monthly</span>
          <div className="relative">
            <input 
              type="checkbox" 
              className="sr-only peer" 
              id="billing-toggle"
            />
            <label 
              htmlFor="billing-toggle"
              className="block w-14 h-8 bg-[#e2dad3] rounded-full cursor-pointer peer-checked:bg-[#ff8c42] peer-focus:outline-none transition-colors duration-300"
            >
              <span className="absolute left-1 top-1 bg-white w-6 h-6 rounded-full transition-transform duration-300 peer-checked:translate-x-6"></span>
            </label>
          </div>
          <div className="flex items-center">
            <span className="text-[#694e42] font-medium">Annual</span>
            <span className="ml-2 text-xs font-medium bg-[#ff8c42] text-white py-1 px-2 rounded-full">
              Save 20%
            </span>
          </div>
        </motion.div>
        
        {/* Badge icons */}
        <motion.div
          className="flex flex-wrap justify-center gap-6 items-center text-[#8a7266]"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <div className="flex items-center">
            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12L11 14L15 10M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span className="text-sm">No credit card required</span>
          </div>
          <div className="flex items-center">
            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12L11 14L15 10M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span className="text-sm">14-day money-back guarantee</span>
          </div>
          <div className="flex items-center">
            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12L11 14L15 10M12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span className="text-sm">Cancel anytime</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default PricingHero;